var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "900" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v(_vm._s(_vm.form.id ? "edit" : "add"))]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.form.id ? "Editar Persona" : "Crear Persona") +
                      " -\n        " +
                      _vm._s(
                        _vm.form.tipo_persona && _vm.form.tipo_persona[0] == 1
                          ? "Servidor público"
                          : "Pasante"
                      ) +
                      "\n      "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "py-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md3: "" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  outline: "",
                                  items: _vm.tipo_documentos,
                                  "item-text": "descripcion",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  label: "Tipo de documento",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.id_tipo_documento,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "id_tipo_documento", $$v)
                                  },
                                  expression: "form.id_tipo_documento"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md3: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  outline: "",
                                  label: "Número de documento",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "200",
                                  disabled: !_vm.form.id_tipo_documento > 0
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.obtenerNrodoc()
                                  }
                                },
                                model: {
                                  value: _vm.form.nro_doc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nro_doc", $$v)
                                  },
                                  expression: "form.nro_doc"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md2: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  outline: "",
                                  label: "Complemento",
                                  maxlength: "200"
                                },
                                model: {
                                  value: _vm.form.nro_complemento,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nro_complemento", $$v)
                                  },
                                  expression: "form.nro_complemento"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md2: "" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  outline: "",
                                  items: _vm.expedidos,
                                  "item-text": "valor",
                                  "item-value": "valor",
                                  label: "Expedido en",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.expedido,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "expedido", $$v)
                                  },
                                  expression: "form.expedido"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md2: "" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  outline: "",
                                  items: _vm.sexos,
                                  "item-text": "valor",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  label: "Sexo",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.id_parametro_sexo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "id_parametro_sexo", $$v)
                                  },
                                  expression: "form.id_parametro_sexo"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass:
                                  "text-field-reducido-border mayuscula",
                                attrs: {
                                  outline: "",
                                  label: "Apellido paterno",
                                  maxlength: "200"
                                },
                                model: {
                                  value: _vm.form.ap_paterno,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "ap_paterno", $$v)
                                  },
                                  expression: "form.ap_paterno"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  outline: "",
                                  label: "Apellido materno",
                                  maxlength: "200"
                                },
                                model: {
                                  value: _vm.form.ap_materno,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "ap_materno", $$v)
                                  },
                                  expression: "form.ap_materno"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass:
                                  "text-field-reducido-border mayuscula",
                                attrs: {
                                  outline: "",
                                  label: "Apellido casada",
                                  maxlength: "200"
                                },
                                model: {
                                  value: _vm.form.ap_casada,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "ap_casada", $$v)
                                  },
                                  expression: "form.ap_casada"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass:
                                  "text-field-reducido-border mayuscula",
                                attrs: {
                                  outline: "",
                                  label: "Nombres",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "200"
                                },
                                model: {
                                  value: _vm.form.nombres,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nombres", $$v)
                                  },
                                  expression: "form.nombres"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", { staticClass: "blue--text" }, [
                              _vm._v("Foto")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              key: _vm.key_actualizacion,
                              staticClass: "text-xs-center",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  class:
                                    this.file == ""
                                      ? "file-empty"
                                      : "file-upload"
                                },
                                [
                                  _c("v-icon", { attrs: { large: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        this.file == "" ? "file_upload" : "done"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("input", {
                                    ref: "file",
                                    staticClass: "input-file",
                                    attrs: {
                                      type: "file",
                                      accept: "image/jpeg, image/png, image/gif"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.handleFileUpload()
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          this.file == ""
                                            ? "Arrastra y suelta cualquier archivo aquí"
                                            : "El archivo se cargo exitosamente!"
                                        ) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          this.file == ""
                                            ? "o haz click aqui para buscar archivos desde el dispositivo"
                                            : "Arrastra y suelta un archivo o haz click aqui para cambiar de archivo"
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _vm.imagen_previsualizada &&
                              _vm.imagen_previsualizada != ""
                                ? _c("v-img", {
                                    attrs: {
                                      "aspect-ratio": 16 / 9,
                                      contain: "",
                                      src: _vm.imagen_previsualizada
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-center",
                              attrs: { xs12: "" }
                            },
                            [
                              this.file.size || _vm.adjunto.size_file
                                ? _c(
                                    "div",
                                    { staticClass: "file-block" },
                                    [
                                      _c("v-icon", [_vm._v("description")]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "file-info" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              this.file.name ||
                                                _vm.adjunto.nombre_archivo
                                            ) + " "
                                          )
                                        ]),
                                        _vm._v(
                                          "\n                  |\n                  "
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.size_file_calculate(
                                                  this.file.size
                                                ) ||
                                                  _vm.size_file_calculate(
                                                    _vm.adjunto.size_file
                                                  )
                                              )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-icon",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.eliminaArchivo()
                                            }
                                          }
                                        },
                                        [_vm._v("delete")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.size
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "red--text body-1 ma-0",
                                      attrs: {
                                        rules: _vm.$validate(["required"])
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                *Archivo demasiado grande(Mayor a 2Mb)\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.denied
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "red--text body-1 ma-0",
                                      attrs: {
                                        rules: _vm.$validate(["required"])
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                *Formato no admitido por el sistema, solo se acepta imagenes\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: !_vm.valid
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8715b3a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8715b3a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/persona/dialogs/CrearActualizarPersona.vue
// module id = null
// module chunks = 